var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane",class:{active: _vm.active},attrs:{"id":_vm.tabId,"role":"tabpanel"}},[_vm._t("default",null,null,_vm.tabData)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }